import React from 'react';
import { PermanentFilterButton } from '../view/PermanentFilterButton';
import { useIntlUds } from '../../../../../translations/UdsIntlProvider';
import { ColumnsConfiguration } from '../../../DataTableAdvancedElements/ColumnsConfiguration';

export const ColumnConfiguration = () => {
  const { intl } = useIntlUds();

  return (
    <ColumnsConfiguration
      CustomElement={({ onClick }) => (
        <PermanentFilterButton
          label={intl.DataTable.ColumnsConfiguration.label}
          onClick={onClick}
          dataTest="permanent-filter-column-configuration"
        />
      )}
    />
  );
};
